module.exports = __webpack_public_path__ + "static/media/2 wukong monkey king chinese mythology.1280x1614.2c0749e3.webp";